module.exports = __webpack_public_path__ + "img/add.79aa0696.svg";